import * as moment from 'moment/moment';

import { InspectionSummaryFilters } from '@main-application/inspections/models/legacy-inspection-summary.model';
import { EnumerationItem } from '@shared/interfaces/enumeration-item';
import { RestPortfolioModel, RestPropertyModel } from '@shared/interfaces/rest-portfolio-model.interface';
import { RestUserModel } from '@shared/interfaces/user.interface';
import { RestTemplateModel } from '@template/models/rest-template-model.interface';

import { DynamicInspectionModel } from '../models/dynamic-inspection.model';
import { InspectionListItemModel } from '../models/inspection-list.model';
import { RestDynamicInspectionModel, RestInspectionsModel } from '../models/rest-inspections-model.interface';

export function mapInspectionsDataSource(
  inspectionList: RestInspectionsModel[],
  templateList: RestTemplateModel[],
  properties: RestPropertyModel[],
  selectedPropertyIds: number[],
  users: RestUserModel[]
): InspectionListItemModel[] {
  const usersMap = new Map(users.map(user => [user.id, user]));

  return inspectionList
    .filter((inspection: RestInspectionsModel) => {
      if (!inspection.unitId && inspection.propertyId) {
        return !selectedPropertyIds || selectedPropertyIds.includes(inspection.propertyId);
      }
      return inspection.unitId && (!selectedPropertyIds || selectedPropertyIds.includes(inspection.unit.property.id));
    })
    .map(
      inspection =>
        new InspectionListItemModel(
          inspection,
          templateList.find(template => template.id == inspection.inspectionTemplateId),
          properties,
          usersMap
        )
    );
}

export function mapDynamicInspectionsDataSource(
  templates: RestDynamicInspectionModel[],
  templateList: RestTemplateModel[],
  properties: RestPropertyModel[],
  workflowSteps: EnumerationItem[],
  users: RestUserModel[],
  portfolios?: RestPortfolioModel[],
  assigneeUserName?: string,
  assigneeUserTooltip?: string
): DynamicInspectionModel[] {
  return templates.map(
    inspection =>
      new DynamicInspectionModel(
        inspection,
        templateList.find(template => template.id == inspection.inspectionTemplateId),
        properties,
        workflowSteps,
        users,
        portfolios,
        assigneeUserName,
        assigneeUserTooltip
      )
  );
}

export default function getInspectionsSummaryFiltersKey(filter: InspectionSummaryFilters): string {
  return JSON.stringify(
    {
      ...filter,
      endDate: moment(filter.endDate).format('YYYY-MM-DD'),
      startDate: moment(filter.startDate).format('YYYY-MM-DD'),
    } || {}
  );
}

export const compareValues = (
  a: number | string | Date | boolean | undefined | null,
  b: number | string | Date | boolean | undefined | null,
  isAsc: boolean
) => {
  let valueA = a;
  let valueB = b;

  const isEmptyPair = (a, b) => (a === null || a === undefined) && (b === null || b === undefined);

  if (isEmptyPair(valueA, valueB)) return 0;
  if (valueA === undefined || valueA === null) return -1 * (isAsc ? 1 : -1);
  if (valueB === undefined || valueB === null) return 1 * (isAsc ? 1 : -1);

  if (typeof a === 'boolean') {
    valueA = a ? 1 : 0;
    valueB = b ? 1 : 0;
  }
  if (a instanceof Date && b instanceof Date) {
    valueA = a.getTime();
    valueB = b.getTime();
  }
  if (typeof a === 'string') {
    valueA = a.toLocaleLowerCase();
  }
  if (typeof b === 'string') {
    valueB = b.toLocaleLowerCase();
  }
  if (valueA === valueB) return 0;
  return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
};
